import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import { getAsset } from '../../../../../../../../util/assets';
import useComponentSize from '../../../../../../../../hooks/useComponentSize';
import { getUtmParamsForQrCodeUrl } from '../helpers';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    join_code: PropTypes.string,
    is_web_gallery: PropTypes.bool,
    album_subtype: PropTypes.string.isRequired,
  }).isRequired,
};

const FlyerPrintTemplateJoinCode = ({ albumFolder }) => {
  const templateRef = useRef(null);
  const { width } = useComponentSize(templateRef);

  return (
    <Fragment>
      <p className="marketing-material-flyer-header-copy">
        Don&apos;t Miss a Moment from <br />
        {albumFolder?.name}!
      </p>

      <p className="marketing-material-flyer-target-enroll-copy">
        Head to <span>waldophotos.com/galleries</span> and enter our join code:
        <br />
        <span className="text-uppercase">{albumFolder.join_code}</span>
      </p>

      <div
        className="marketing-material-flyer-qrcode-secondary wg-flyer-qrcode"
        style={{
          top: '56%',
          right: `calc(50% - ${Math.round((width * 0.25 ?? 500) / 2)}px)`,
        }}
      >
        <QRCode
          renderAs="canvas"
          value={getUtmParamsForQrCodeUrl({
            url: `https://waldophotos.com/galleries${
              albumFolder.join_code ? `?joinCode=${albumFolder.join_code}` : ''
            }`,
            albumFolder,
          })}
          size={width * 0.25 ?? 500}
        />
      </div>

      <img
        ref={templateRef}
        src={getAsset(
          '/marketing-material/MARKETING_FLYER_GENERAL_1_PF_EO.png',
        )}
        alt=""
      />
    </Fragment>
  );
};

FlyerPrintTemplateJoinCode.propTypes = propTypes;

export default FlyerPrintTemplateJoinCode;
